import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import "../css/main.css";
import servicii from "../images/servicii-img.png";
import smallServicii from "../images/small-servicii.png";
import "../css/main.css";

const PracticaPsihologica = () => {
  return (
    <div>
      <Header />

      <div className="contributii blog servicii serviciu-page">
        <div className="container">
          <div className="info-section text-b">AWARE</div>
          <h1 className="text-b">Practica Psihologică</h1>
          <p>
            Practica psihologica din cadrul Centrului aware s-a nascut din
            nevoia de contributie.
          </p>
          <p>
            Oferim un context organizat de obserrvare si invatare, studentilor
            din cadrul facultatilor de psihologie prin:
          </p>
          <ul>
            <li>ateliere informationale</li>
            <li>ateliere pe diverse teme de interes</li>
            <li>prezentari studii de caz</li>
            <li>organizarea si antrenarea proiectelor in echipa</li>
            <li>
              introducere in psihoterapie: discutii pe baza studiilor de caz;
              elemente de setting ale procesului psihoterapeutic
            </li>
            <li>
              introducere in psihologie clinica: elemente introductive,
              prezentare modele rapoarte psihologice, completare teste, auto
              administrae, scorare, interpretare.
            </li>
          </ul>

          <p>
            Pentru ca noi facem din sanatatea psihica o prioritatea consideram
            ca e responsabilitatea noastra, ca specialisti din domeniul
            sanatatii mintale, sa oferim contexte de manifestare si invatare
            viitorilor nostri colegi.
          </p>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default PracticaPsihologica;
